var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSorting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.208H37V13.208H16V11.208Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16.208H35V18.208H17V16.208Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 21.208H33V23.208H19V21.208Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 26.208H31V28.208H21V26.208Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.96 28.208L14.136 23.264H7.512L5.688 28.208H3L9.504 11H12.192L18.672 28.208H15.96ZM11.688 16.184C11.64 16.008 11.552 15.744 11.424 15.392C11.312 15.024 11.2 14.656 11.088 14.288C10.976 13.904 10.888 13.592 10.824 13.352C10.744 13.672 10.648 14.024 10.536 14.408C10.44 14.776 10.344 15.12 10.248 15.44C10.152 15.744 10.072 15.992 10.008 16.184L8.28 21.008H13.416L11.688 16.184Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSorting);
export default __webpack_public_path__ + "static/media/sorting.4a33fecd059135a49055cdcd85aba2d4.svg";
export { ForwardRef as ReactComponent };